export enum TripInformationConstants {
  NOT_IMPLEMENTED = 'tripInformation/NOT_IMPLEMENTED',
  SET_BASE = 'tripInformation/SET_BASE',
  SET_UNIT = 'tripInformation/SET_UNIT',
  SET_STAFFING_LEVEL = 'tripInformation/SET_STAFFING_LEVEL',
  SET_UNIT_EQUIPMENT = 'tripInformation/SET_UNIT_EQUIPMENT',
  SET_SHIFT = 'tripInformation/SET_SHIFT',
  SET_DISPATCH_ID = 'tripInformation/SET_DISPATCH_ID',
  SET_REGISTRATION_TAIL_NUMBER = 'tripInformation/SET_REGISTRATION_TAIL_NUMBER',
  SET_DISPATCH_PRIORITY = 'tripInformation/SET_DISPATCH_PRIORITY',
  SET_EMD_PERFORMED = 'tripInformation/SET_EMD',
  SET_EMD_PERFORMED_PNNV = 'tripInformation/SET_EMD_PERFORMED_PNNV',
  SET_EMD = 'tripInformation/SET_EMD_CARD',
  SET_TYPE_OF_SERVICE = 'tripInformation/SET_TYPE_OF_SERVICE',
  SET_CALL_TYPE = 'tripInformation/SET_CALL_TYPE',
  SET_SCHEDULED = 'tripInformation/SET_SCHEDULED',
  SET_STANDBY_PURPOSE = 'tripInformation/SET_STANDBY_PURPOSE',
  SET_PATIENT_CATEGORY = 'tripInformation/SET_PATIENT_CATEGORY',
  SET_DISPATCHED_AS = 'tripInformation/SET_DISPATCHED_AS',
  SET_DISPOSITION = 'tripInformation/SET_DISPOSITION',
  SET_UNIT_DISPOSITION = 'tripInformation/SET_UNIT_DISPOSITION',
  SET_PATIENT_EVALUATION = 'tripInformation/SET_PATIENT_EVALUATION',
  SET_PATIENT_EVALUATION_PNNV = 'tripInformation/SET_PATIENT_EVALUATION_PNNV',
  SET_CREW_DISPOSITION = 'tripInformation/SET_CREW_DISPOSITION',
  SET_CREW_DISPOSITION_PNNV = 'tripInformation/SET_CREW_DISPOSITION_PNNV',
  SET_TRANSPORT_DISPOSITION = 'tripInformation/SET_TRANSPORT_DISPOSITION',
  SET_TRANSPORT_DISPOSITION_PNNV = 'tripInformation/SET_TRANSPORT_DISPOSITION_PNNV',
  SET_REFUSAL_RELEASE_REASON = 'tripInformation/SET_REFUSAL_RELEASE_REASON',
  SET_AMBULANCE_TRANSPORT_CODE = 'tripInformation/SET_AMBULANCE_TRANSPORT_CODE',
  SET_MASS_CASUALTY = 'tripInformation/SET_MASS_CASUALTY',
  SET_MASS_CASUALTY_PNNV = 'tripInformation/SET_MASS_CASUALTY_PNNV',
  SET_DISPATCH_LOCATION = 'tripInformation/SET_DISPATCH_LOCATION',
  SET_VEHICLE_GPS_N = 'tripInformation/SET_VEHICLE_GPS_N',
  SET_VEHICLE_GPS_E = 'tripInformation/SET_VEHICLE_GPS_E',
  SET_VEHICLE_USNG = 'tripInformation/SET_VEHICLE_USNG',
  SET_VEHICLE_MILEAGE_START = 'tripInformation/SET_VEHICLE_MILEAGE_START',
  SET_VEHICLE_MILEAGE_REF = 'tripInformation/SET_VEHICLE_MILEAGE_REF',
  SET_VEHICLE_MILEAGE_END = 'tripInformation/SET_VEHICLE_MILEAGE_END',
  SET_VEHICLE_MILEAGE_REC = 'tripInformation/SET_VEHICLE_MILEAGE_REC',
  SET_VEHICLE_MILEAGE_LOADED = 'tripInformation/SET_VEHICLE_MILEAGE_LOADED',
  SET_VEHICLE_MILEAGE_TOTAL = 'tripInformation/SET_VEHICLE_MILEAGE_TOTAL',
  CALCULATE_VEHICLE_MILEAGE_LOADED = 'pickupAddress/CALCULATE_VEHICLE_MILEAGE_LOADED',
  CALCULATE_VEHICLE_MILEAGE_TOTAL = 'pickupAddress/CALCULATE_VEHICLE_MILEAGE_TOTAL',
  SET_VEHICLE_MILEAGE_LPM = 'tripInformation/SET_VEHICLE_MILEAGE_LPM',
  SET_VEHICLE_MILEAGE_ODOM = 'tripInformation/SET_VEHICLE_MILEAGE_ODOM',
  SET_VEHICLE_GRID = 'tripInformation/SET_VEHICLE_GRID',
  SET_API_RESPONSE = 'tripInformation/SET_API_RESPONSE',
  SAVE_TRIP_INFORMATION = 'tripInformation/SAVE_TRIP_INFORMATION',
  SET_TRIP_INFORMATION = 'tripInformation/SET_TRIP_INFORMATION',
  RESET_TRIP_INFORMATION = 'tripInformation/RESET_TRIP_INFORMATION',
  CALCULATE_VEHICLE_USNG = 'tripInformation/CALCULATE_TRIP_INFORMATION_USNG',
  SET_UNIT_OPTION = 'tripInformation/SET_UNIT_OPTION',
  SET_BASE_OPTION = 'tripInformation/SET_BASE_OPTION',
  SET_REG_TAIL_NUMBER_OPTION = 'tripInformation/SET_REG_TAIL_NUMBER_OPTION',
  SET_LOCAL_ID = 'tripInformation/SET_LOCAL_ID',
  SET_TEAM = 'tripInformation/SET_TEAM',
  SET_TEAM_CARE_ONLY = 'tripInformation/SET_TEAM_CARE_ONLY',
  SET_EQUIPMENT = 'tripInformation/SET_EQUIPMENT',
  SET_PROVIDER_ROLES = 'tripInformation/SET_PROVIDER_ROLES',
  SET_MAX_ALT = 'tripInformation/SET_MAX_ALT',
  SET_FLIGHT_PLAN = 'tripInformation/SET_FLIGHT_PLAN',
}

export const AIR_UNIT_TYPES = [5, 6]
